module.exports = __webpack_public_path__ + "img/test-recently.15ebd4c5.png";